import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { updateTwoFactorAuth } from "../../store/Actions/userAction";

export const TwoFactorAuth = () => {
  const dispatch = useDispatch();
  const { user, loading } = useSelector((state) => state.user);

  const [twoFactorAuthEnabled, setTwoFactorAuthEnabled] = useState(false);

  useEffect(() => {
    if (user?.emailMarketing !== undefined) {
      setTwoFactorAuthEnabled(user.twoFactorEnabled);
    }
  }, [user]);

  const handleTwoFactorOn = () => {
    dispatch(updateTwoFactorAuth(true));
    setTwoFactorAuthEnabled(!twoFactorAuthEnabled);
  };

  const handleTwoFactorOff = () => {
    dispatch(updateTwoFactorAuth(false));
    setTwoFactorAuthEnabled(!twoFactorAuthEnabled);
  };

  return (
    <Card
      sx={{
        borderRadius: "16px",
        px: 2,
        pt: { xs: 1, sm: 2 },
        mt: 2,
        boxShadow: "4px 4px 20px 0px #0000001A",
      }}
    >
      <CardContent>
        <Grid container>
          <Grid item xs={12} md={8}>
            <Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                }}
              >
                {t("profile.twofactorauth.title")}
              </Typography>

              <Box sx={{}}>
                <Typography variant="body2">
                  {t("profile.twofactorauth.description")}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: { md: "end" },
              alignItems: "center",
            }}
          >
            {!twoFactorAuthEnabled && (
              <Button
                className="green-text-btn"
                onClick={handleTwoFactorOn}
                sx={{
                  color: "socialLink.main",
                  fontSize: "12px",
                  width: "fit-content!important",
                  pl: 0,
                }}
              >
                {t("profile.twofactorauth.onTxt")}
              </Button>
            )}
            {twoFactorAuthEnabled && (
              <Button
                onClick={handleTwoFactorOff}
                sx={{
                  color: "info.secondary",
                  fontSize: "12px",
                  width: "fit-content!important",
                  pl: 0,
                }}
              >
                {t("profile.twofactorauth.offTxt")}
              </Button>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TwoFactorAuth;
